// Arabic M2 strings — DEVELOPMENT DRAFT by Claude (PD-011); unreviewed until decision H-10.
import type { enM2 } from './en-m2.ts';
import type { Message } from './types.ts';

export const arM2: { readonly [K in keyof typeof enM2]: Message } = {
  'api.visitClosed': 'هذه الزيارة ملغاة أو انتهت، لذلك لا يمكن تغييرها.',
  'api.scheduleInvalid': 'نافذة الزيارة تحتاج إلى مراجعة.',
  'api.submissionIncomplete': 'لا يمكن تقديم الزيارة بعد. أكمِل التفاصيل المطلوبة.',
  'api.roomConflict': 'هذه الغرفة محجوزة لجزء من هذا الوقت. اختر وقتًا أو غرفة أخرى.',
  'api.capacityExceeded': 'تتسع هذه الوجهة لـ{capacity} أشخاص؛ وفي الزيارة {count}.',
  'api.visitImpact': 'يؤثر هذا التغيير في الموافقات الحالية. راجع الأثر وأكّد لإعادة طلب الموافقة.',
  'api.lastParticipant': 'تحتاج الزيارة المقدَّمة إلى زائر واحد على الأقل. ألغِ الزيارة بدلًا من ذلك.',
  'api.hostInactive': 'ملف المضيف الخاص بك غير نشط. اطلب من المسؤول إعادة تفعيله.',
  'api.hostHasVisits': 'لدى هذا المضيف زيارات قادمة. أعِد إسنادها إلى مضيف آخر أولًا.',
  'api.ownVisitApproval': 'أنت تستضيف هذه الزيارة أو أنشأتها، لذا يجب أن يقرّر فيها مراجع آخر.',
  'api.approvalNotAssigned': 'هذه الموافقة مسندة إلى شخص آخر.',
  'api.approvalNotPending': 'لم تعد هذه الموافقة بانتظار قرار.',
  'api.approvalStale': 'تغيّرت الزيارة بعد أن فتحتها. راجع التفاصيل الحالية قبل اتخاذ القرار.',
  'api.invitationInvalid': 'رابط الدعوة هذا غير صالح. ربما انتهت صلاحيته أو استُبدل أو تغيّرت الزيارة. تواصل مع مضيفك للحصول على دعوة جديدة.',
  'api.invitationNotCleared': 'لا يمكن إرسال دعوة إلا بعد اعتماد الزيارة لهذا الشخص.',
  'v.noEmail': 'لا يوجد بريد إلكتروني لهذا الزائر. أنشئ رابطًا لمشاركته بدلًا من ذلك.',
  'api.policyDraftExists': 'توجد مسودة بالفعل لهذا النطاق. انشرها أو تجاهلها أولًا.',

  'v.date': 'استخدم تاريخًا بالصيغة YYYY-MM-DD.',
  'v.phone': 'أدخِل رقم هاتف باستخدام الأرقام أو المسافات أو الأقواس أو الشرطات.',
  'v.policyKey': 'استخدم من 1 إلى 40 حرفًا لاتينيًا صغيرًا أو رقمًا أو شرطة، يبدأ بحرف.',
  'v.policyDuplicate': 'هذا الرمز مستخدم بالفعل.',
  'v.policyUnknownDependency': 'يعتمد على مرحلة غير موجودة هنا.',
  'v.policySelfDependency': 'لا يمكن أن تعتمد المرحلة على نفسها.',
  'v.policyCycle': 'تعتمد هذه المراحل على بعضها في حلقة.',
  'v.policyNoActiveCategory': 'أبقِ فئة واحدة نشطة على الأقل.',
  'v.policyApproverUnknown': 'اختر شخصًا نشطًا كمعتمِد محدد.',
  'v.timeGap': 'هذا الوقت المحلي غير موجود في ذلك التاريخ بسبب تغيير التوقيت الصيفي. اختر وقتًا آخر.',
  'v.timeAmbiguous': 'يتكرر هذا الوقت المحلي مرتين في ذلك التاريخ بسبب تغيير التوقيت الصيفي. اختر المقصود.',
  'v.endBeforeStart': 'يجب أن تكون النهاية بعد البداية.',
  'v.visitTooLong': 'يمكن أن تستمر زيارات هذه الفئة {days} أيام كحد أقصى.',
  'v.visitInPast': 'انتهت نافذة هذه الزيارة بالفعل.',
  'v.destinationUnavailable': 'اختر موقعًا نشطًا في هذا الموقع.',
  'v.hostUnavailable': 'اختر مضيفين نشطين.',
  'v.categoryUnknown': 'اختر فئة زوار نشطة.',
  'v.personUnknown': 'هذا الملف غير متاح.',
  'v.personDuplicate': 'هذا الشخص مضاف إلى الزيارة بالفعل.',
  'v.noParticipants': 'أضِف زائرًا واحدًا على الأقل.',
  'v.recurrenceNone': 'لا توجد تواريخ تطابق نمط التكرار هذا.',
  'v.recurrenceTooMany': 'يمكن أن تضم السلسلة {max} تكرارًا كحد أقصى.',
  'v.noteUnknown': 'الملاحظة المراد تصحيحها ليست في هذه الزيارة.',
  'v.rejectReason': 'اذكر سبب الرفض.',
  'v.approverConflict': 'هذا الشخص يستضيف الزيارة أو أنشأها ولا يمكنه البتّ فيها.',
  'v.approverNoGrant': 'لا يمكن لهذا الشخص اعتماد الزيارات في هذا الموقع.',
  'v.userUnknown': 'اختر مستخدمًا نشطًا.',
  'v.hostUserLinked': 'هذا المستخدم مرتبط بالفعل بملف مضيف آخر.',
  'v.hostEmployeeTaken': 'رقم الموظف هذا مستخدم لدى مضيف آخر.',

  'visit.planning.draft': 'مسودة',
  'visit.planning.submitted': 'مقدَّمة',
  'visit.planning.cancelled': 'ملغاة',
  'visit.planning.expired': 'منتهية',
  'state.approval.not_required': 'لا تتطلب موافقة',
  'state.approval.pending': 'الموافقة قيد الانتظار',
  'state.approval.approved': 'موافق عليها',
  'state.approval.rejected': 'مرفوضة',
  'state.approval.expired': 'انتهت صلاحية الموافقة',
  'state.approval.invalidated': 'سُحبت الموافقة',
  'state.evidence.missing': 'لا يوجد إثبات بعد',
  'state.evidence.uploaded': 'تم رفع الإثبات',
  'state.evidence.scanning': 'جارٍ فحص الإثبات',
  'state.evidence.review_pending': 'مراجعة الإثبات قيد الانتظار',
  'state.evidence.accepted': 'الإثبات مقبول',
  'state.evidence.rejected': 'الإثبات مرفوض',
  'state.evidence.expired': 'الإثبات منتهي الصلاحية',
  'state.evidence.unavailable': 'الإثبات غير متاح',
  'state.presence.no_observation': 'لم يُرصد',
  'state.presence.observed_onsite': 'رُصد في الموقع',
  'state.presence.observed_departed': 'رُصدت مغادرته',
  'state.presence.unknown_conflicting': 'الحضور غير معروف',
  'state.credential.none': 'لا يوجد تصريح',
  'state.credential.requested': 'طُلب التصريح',
  'state.credential.issued_active': 'التصريح نشط',
  'state.credential.revoke_pending': 'الإلغاء قيد الانتظار',
  'state.credential.revoked': 'أُلغي التصريح',
  'state.credential.expired': 'انتهت صلاحية التصريح',
  'state.credential.failed': 'فشل التصريح',
  'state.credential.unknown': 'نتيجة التصريح غير معروفة',
  'task.status.waiting': 'بانتظار مرحلة سابقة',
  'task.status.pending': 'بانتظار القرار',
  'task.status.blocked': 'متوقفة — لا يوجد مراجع مؤهل',
  'task.status.approved': 'موافق عليها',
  'task.status.rejected': 'مرفوضة',
  'task.status.invalidated': 'مسحوبة',
  'task.status.closed': 'مغلقة',
  'task.closed.material_change': 'سُحبت بعد تغيير جوهري',
  'task.closed.participant_removed': 'سُحبت: أُزيل الزائر',
  'task.closed.visit_cancelled': 'سُحبت: أُلغيت الزيارة',
  'task.closed.rejected_elsewhere': 'أُغلقت: رُفضت مرحلة أخرى',

  'visits.title': 'الزيارات والدعوات',
  'visits.intro': 'خطّط للزيارات الفردية والجماعية والمتكررة. يحتفظ كل مشارك بدورة حياة مستقلة.',
  'visits.new': '+ زيارة جديدة',
  'visits.tab.upcoming': 'القادمة',
  'visits.tab.drafts': 'المسودات',
  'visits.tab.past': 'السابقة',
  'visits.tab.cancelled': 'الملغاة',
  'visits.scope.mine': 'زيارات أستضيفها',
  'visits.scope.site': 'الموقع بالكامل',
  'visits.scopeLabel': 'عرض',
  'visits.search': 'ابحث بالعنوان أو اسم الزائر',
  'visits.register': 'سجل الزيارات',
  'visits.count': { zero: 'لا توجد سجلات ضمن النطاق', one: 'سجل واحد ضمن النطاق', two: 'سجلان ضمن النطاق', few: '{count} سجلات ضمن النطاق', many: '{count} سجلًا ضمن النطاق', other: '{count} سجل ضمن النطاق' },
  'visits.col.visit': 'الزيارة',
  'visits.col.when': 'الموعد ({zone})',
  'visits.col.host': 'المضيف',
  'visits.col.destination': 'الوجهة',
  'visits.col.people': 'الأشخاص',
  'visits.col.approval': 'الموافقة',
  'visits.col.planning': 'التخطيط',
  'visits.empty': 'لا توجد زيارات في هذا العرض.',
  'visits.noSchedule': 'غير مجدولة',
  'visits.untitled': 'مسودة بلا عنوان',
  'visits.approvalSummary': '{approved} موافق · {pending} قيد الانتظار · {rejected} مرفوض',
  'visits.noApproval': 'لا تتطلب موافقة',
  'visits.daily': 'يوميًا {start}–{end}',
  'visits.series': 'متكررة',

  'vform.newTitle': 'التخطيط لزيارة',
  'vform.editTitle': 'تعديل الزيارة',
  'vform.intro': 'احفظ مسودة في أي وقت. يتحقق التقديم من سياسة هذا الموقع ويبدأ الموافقات.',
  'vform.details': 'تفاصيل الزيارة',
  'vform.title': 'العنوان',
  'vform.category': 'فئة الزائر',
  'vform.categoryHint': 'تأتي الفئات والتفاصيل المطلوبة والموافقات من السياسة المنشورة (الإصدار {version}).',
  'vform.categoryStages': { zero: '{label} — دون موافقة', one: '{label} — مرحلة موافقة واحدة', two: '{label} — مرحلتا موافقة', few: '{label} — {count} مراحل موافقة', many: '{label} — {count} مرحلة موافقة', other: '{label} — {count} مرحلة موافقة' },
  'vform.choose': 'اختر…',
  'vform.purpose': 'الغرض',
  'vform.destination': 'الوجهة',
  'vform.destinationNone': 'بلا وجهة محددة',
  'vform.capacity': '{name} (السعة {capacity})',
  'vform.restricted': 'مقيدة',
  'vform.schedule': 'نافذة الزيارة',
  'vform.zoneNote': 'الأوقات بالتوقيت المحلي لـ{site}: {zone} ({offset}).',
  'vform.mode': 'نوع الجدول',
  'vform.mode.continuous': 'نافذة واحدة متصلة',
  'vform.mode.daily': 'عدة أيام، بساعات يومية فقط',
  'vform.modeDailyHint': 'يقتصر الدخول على الساعات اليومية في كل يوم — ولا يشمل الليل أبدًا.',
  'vform.startDate': 'تاريخ البداية',
  'vform.startTime': 'وقت البداية',
  'vform.endDate': 'تاريخ النهاية',
  'vform.endTime': 'وقت النهاية',
  'vform.dailyStart': 'الافتتاح اليومي',
  'vform.dailyEnd': 'الإغلاق اليومي',
  'vform.ambiguous': 'يتكرر هذا الوقت مرتين لأن الساعة تتغير في ذلك اليوم.',
  'vform.ambiguous.earlier': 'المرة الأولى (قبل التغيير)',
  'vform.ambiguous.later': 'المرة الثانية (بعد التغيير)',
  'vform.repeat': 'تكرار أسبوعي',
  'vform.repeatHint': 'يصبح كل تكرار زيارة مستقلة بموافقاتها الخاصة؛ وتغيير أحدها لا يغيّر البقية.',
  'vform.weekdays': 'في',
  'vform.until': 'حتى',
  'vform.hosts': 'المضيفون',
  'vform.primaryHost': 'المضيف الرئيسي',
  'vform.primaryHostSelf': '{name} (أنت)',
  'vform.primaryHostHint': 'يبقى المضيف الرئيسي مسؤولًا عن الزيارة.',
  'vform.additionalHosts': 'مضيفون إضافيون',
  'vform.additionalHostsHint': 'يشارك المضيفون الإضافيون المسؤولية والإشعارات، ولا يحصلون على صلاحية الموافقة.',
  'vform.addHost': 'إضافة مضيف',
  'vform.removeHost': 'إزالة {name}',
  'vform.visitors': 'الزوار',
  'vform.visitorsHint': 'يحتفظ كل زائر بحالة مستقلة للموافقة والهوية والحضور والتصريح.',
  'vform.visitor': 'الزائر {n}',
  'vform.givenName': 'الاسم الأول',
  'vform.familyName': 'اسم العائلة',
  'vform.email': 'البريد الإلكتروني',
  'vform.phone': 'الجوال',
  'vform.organisation': 'الجهة',
  'vform.required': 'مطلوب وفق السياسة',
  'vform.addVisitor': 'إضافة زائر',
  'vform.removeVisitor': 'إزالة الزائر {n}',
  'vform.existingProfile': 'استخدام ملف موجود: {name}',
  'vform.useNew': 'إدخال شخص جديد بدلًا من ذلك',
  'vform.matches': 'ملفات قد تكون موجودة',
  'vform.matchesNote': 'تطابق بيانات الاتصال ليس دليلًا على الهوية. استخدم الملف فقط إذا كان للشخص نفسه.',
  'vform.matchReason': 'تطابق في {reasons}',
  'vform.reason.email': 'البريد الإلكتروني',
  'vform.reason.phone': 'الجوال',
  'vform.reason.name': 'الاسم',
  'vform.useProfile': 'استخدام هذا الملف',
  'vform.keepSeparate': 'إبقاؤه منفصلًا',
  'vform.saveDraft': 'حفظ المسودة',
  'vform.submit': 'تقديم للموافقة',
  'vform.saveChanges': 'حفظ التغييرات',
  'vform.cancel': 'رجوع',
  'vform.seriesResult': 'أُنشئت السلسلة',
  'vform.seriesOutcome': '{date}: {outcome}',
  'vform.outcome.draft': 'حُفظت مسودة',
  'vform.outcome.submitted': 'قُدّمت',
  'vform.outcome.failed': 'لم تُقدَّم — {message}',
  'vform.impactTitle': 'إعادة طلب الموافقة؟',
  'vform.impactBody': { zero: 'تغيير {fields} تغيير جوهري. سيُطلب الاعتماد مجددًا وفق السياسة الحالية.', one: 'تغيير {fields} تغيير جوهري. سيُسحب قرار موافقة واحد ويُطلب الاعتماد مجددًا.', two: 'تغيير {fields} تغيير جوهري. سيُسحب قرارا موافقة ويُطلب الاعتماد مجددًا.', few: 'تغيير {fields} تغيير جوهري. ستُسحب {count} قرارات موافقة ويُطلب الاعتماد مجددًا.', many: 'تغيير {fields} تغيير جوهري. سيُسحب {count} قرار موافقة ويُطلب الاعتماد مجددًا.', other: 'تغيير {fields} تغيير جوهري. سيُسحب {count} قرار موافقة ويُطلب الاعتماد مجددًا.' },
  'vform.impactConfirm': 'حفظ وإعادة طلب الموافقة',
  'vform.conflictTitle': 'غيّر شخص آخر هذه الزيارة',
  'vform.conflictBody': 'لم تُحفظ تعديلاتك. قارنها بالإصدار الأحدث، ثم أعِد التحميل وطبّق تغييراتك مجددًا.',
  'vform.conflictYours': 'قيمتك',
  'vform.conflictCurrent': 'القيمة الحالية',
  'vform.reload': 'تحميل الإصدار الأحدث',
  'vform.field.categoryCode': 'الفئة',
  'vform.field.destinationId': 'الوجهة',
  'vform.field.startsAt': 'البداية',
  'vform.field.endsAt': 'النهاية',
  'vform.field.scheduleMode': 'نوع الجدول',
  'vform.field.dailyStart': 'الافتتاح اليومي',
  'vform.field.dailyEnd': 'الإغلاق اليومي',
  'vform.field.primaryHostId': 'المضيف الرئيسي',
  'weekday.1': 'الإثنين',
  'weekday.2': 'الثلاثاء',
  'weekday.3': 'الأربعاء',
  'weekday.4': 'الخميس',
  'weekday.5': 'الجمعة',
  'weekday.6': 'السبت',
  'weekday.7': 'الأحد',

  'visit.unavailable': 'الزيارة غير متاحة',
  'visit.unavailableBody': 'هذه الزيارة غير موجودة أو خارج نطاق عرضك.',
  'visit.back': 'العودة إلى الزيارات',
  'visit.copy': 'نسخ',
  'visit.edit': 'تعديل',
  'visit.cancel': 'إلغاء الزيارة',
  'visit.submit': 'تقديم للموافقة',
  'visit.journey': 'مسار الزيارة',
  'visit.journeyNote': 'تبقى الحقائق مستقلة؛ فإرسال الدعوة أو الموافقة لا يعني السماح بالدخول.',
  'visit.step.plan': 'التخطيط',
  'visit.step.approval': 'الموافقة',
  'visit.step.identity': 'الهوية',
  'visit.step.presence': 'الحضور',
  'visit.step.credential': 'التصريح',
  'visit.details': 'تفاصيل الزيارة',
  'visit.detailsSub': 'سجل موثوق واحد',
  'visit.f.host': 'المضيف الرئيسي',
  'visit.f.additionalHosts': 'مضيفون إضافيون',
  'visit.f.destination': 'الوجهة',
  'visit.f.window': 'نافذة الزيارة',
  'visit.f.windows': { one: 'نافذة معتمدة واحدة', two: 'نافذتان معتمدتان', few: '{count} نوافذ معتمدة', many: '{count} نافذة معتمدة', other: '{count} نافذة معتمدة' },
  'visit.f.category': 'الفئة',
  'visit.f.purpose': 'الغرض',
  'visit.f.site': 'الموقع',
  'visit.f.policy': 'إصدار السياسة',
  'visit.f.policyValue': 'الإصدار {number}',
  'visit.f.version': 'إصدار السجل',
  'visit.f.copiedFrom': 'منسوخة من',
  'visit.f.occurrence': 'تكرار ضمن سلسلة',
  'visit.people': 'الأشخاص',
  'visit.peopleSub': 'لكل شخص دورة حياة مستقلة.',
  'visit.col.person': 'الشخص',
  'visit.col.approval': 'الموافقة',
  'visit.col.evidence': 'الهوية',
  'visit.col.presence': 'الحضور',
  'visit.col.credential': 'التصريح',
  'visit.removed': 'أُزيل',
  'visit.removeVisitor': 'إزالة',
  'visit.removeTitle': 'إزالة {name} من هذه الزيارة؟',
  'visit.removeBody': 'تُسحب مهام الموافقة الخاصة به. لا يتأثر الزوار الآخرون.',
  'visit.addVisitors': 'إضافة زوار',
  'visit.masked': 'بيانات الاتصال محجوبة لدورك.',
  'visit.approvals': 'الموافقات',
  'visit.approvalsSub': 'أُنشئت من إصدار السياسة {version}؛ ولا تُعاد كتابة القرارات أبدًا.',
  'visit.approvalsNone': 'لا توجد مهام موافقة.',
  'visit.anyApprover': 'أي معتمِد مؤهل في الموقع',
  'visit.decidedBy': '{name} · {when}',
  'visit.next': 'الإجراء التالي',
  'visit.nextDraft': 'أكمِل هذه التفاصيل للتقديم:',
  'visit.nextReady': 'جاهزة للتقديم.',
  'visit.nextPending': 'بانتظار قرارات الموافقة.',
  'visit.nextApproved': 'سُجّلت كل الموافقات المطلوبة. تبقى الهوية والوصول والدخول فحوصًا منفصلة.',
  'visit.nextCancelled': 'ملغاة: {reason}. أُبطلت الدعوات، وتُحفظ حقائق الحضور والوصول.',
  'visit.notes': 'الملاحظات',
  'visit.notesSub': 'مؤرخة وتُضاف فقط. تشير التصحيحات إلى الأصل.',
  'visit.notesNone': 'لا توجد ملاحظات بعد.',
  'visit.noteAdd': 'إضافة ملاحظة',
  'visit.noteBody': 'الملاحظة',
  'visit.noteCorrect': 'تصحيح',
  'visit.noteCorrecting': 'تصحيح الملاحظة المؤرخة {when}',
  'visit.noteCorrection': 'تصحيح لملاحظة سابقة',
  'visit.noteCorrected': 'صُحّحت لاحقًا',
  'visit.cancelTitle': 'إلغاء هذه الزيارة؟',
  'visit.cancelBody': { one: 'تُسحب موافقات زائر واحد وتُبطَل الدعوات. الإلغاء لا يسجّل مغادرة أي شخص.', two: 'تُسحب موافقات زائرين وتُبطَل الدعوات. الإلغاء لا يسجّل مغادرة أي شخص.', few: 'تُسحب موافقات {count} زوار وتُبطَل الدعوات. الإلغاء لا يسجّل مغادرة أي شخص.', many: 'تُسحب موافقات {count} زائرًا وتُبطَل الدعوات. الإلغاء لا يسجّل مغادرة أي شخص.', other: 'تُسحب موافقات {count} زائر وتُبطَل الدعوات. الإلغاء لا يسجّل مغادرة أي شخص.' },
  'visit.cancelConfirm': 'إلغاء الزيارة',
  'visit.copied': 'نُسخت في مسودة جديدة. لا تُنسخ الموافقات ولا التصاريح.',

  'approvals.title': 'صندوق الموافقات',
  'approvals.intro': 'راجع الحقائق الحالية. تغيير التفاصيل الجوهرية للزيارة يتطلب قرارًا جديدًا.',
  'approvals.policies': 'سياسات سير العمل',
  'approvals.m.queue': 'قائمة موقعك',
  'approvals.m.queueSub': 'قرارات مسندة إليك أو إلى أي معتمِد في الموقع',
  'approvals.m.blocked': 'متوقفة',
  'approvals.m.blockedSub': 'لا يوجد مراجع مؤهل — لا تُتجاوز أبدًا',
  'approvals.m.mode': 'نمط القرار',
  'approvals.m.modeValue': 'بشري',
  'approvals.m.modeSub': 'لا موافقة آلية',
  'approvals.tab.pending': 'بانتظار قرار',
  'approvals.tab.decided': 'قرّرتها أنت',
  'approvals.tab.blocked': 'متوقفة',
  'approvals.col.visitor': 'الزائر',
  'approvals.col.visit': 'الزيارة',
  'approvals.col.when': 'الموعد',
  'approvals.col.stage': 'المرحلة',
  'approvals.col.action': 'الإجراء',
  'approvals.empty': 'لا شيء بانتظار القرار هنا.',
  'approvals.review': 'مراجعة القرار',
  'approvals.ownVisit': 'أنت تستضيف هذه الزيارة — يقرّر فيها مراجع آخر',
  'approvals.notAssigned': 'مسندة إلى شخص آخر',
  'approvals.restricted': 'منطقة مقيدة',
  'approvals.decisionTitle': 'قرار الموافقة',
  'approvals.decisionSub': '{stage} · إصدار السياسة {version}',
  'approvals.facts': 'الحقائق التي تقرّر بشأنها (إصدار الزيارة {version})',
  'approvals.decision': 'القرار',
  'approvals.approve': 'موافقة',
  'approvals.reject': 'رفض',
  'approvals.reason': 'السبب',
  'approvals.reasonHint': 'مطلوب عند الرفض. يُسجَّل مع القرار.',
  'approvals.record': 'تسجيل القرار',
  'approvals.recorded': 'سُجّل القرار.',
  'approvals.reassign': 'إعادة إسناد',
  'approvals.reassignTitle': 'إعادة إسناد الموافقة',
  'approvals.reassignTo': 'إسناد إلى',
  'approvals.reassignAny': 'أي معتمِد مؤهل في الموقع',
  'approvals.reassignUser': 'شخص محدد',
  'approvals.reassignUserId': 'الشخص',
  'approvals.reassignHint': 'لا يمكن اختيار مضيف الزيارة أو المضيفين المشاركين أو منشئها.',
  'approvals.reassignSave': 'إعادة إسناد',
  'approvals.decidedOn': 'تقرّر في {when}',

  'vpolicy.title': 'السياسات وسير عمل الموافقات',
  'vpolicy.intro': 'فئات زوار وتفاصيل مطلوبة ومراحل موافقة بإصدارات. الإصدارات المنشورة لا تتغير؛ ويسجّل كل قرار الإصدار الذي أنتجه.',
  'vpolicy.scope': 'نطاق السياسة',
  'vpolicy.scope.org': 'المؤسسة (كل المواقع)',
  'vpolicy.scope.site': '{name} (تجاوز خاص بالموقع)',
  'vpolicy.inForce': 'السارية',
  'vpolicy.inForceSub': 'الإصدار {number} · نُشر {when}',
  'vpolicy.inheritsOrg': 'لا يوجد تجاوز لهذا الموقع؛ تُطبَّق سياسة المؤسسة (الإصدار {number}).',
  'vpolicy.none': 'لا توجد سياسة منشورة.',
  'vpolicy.col.category': 'الفئة',
  'vpolicy.col.required': 'التفاصيل المطلوبة',
  'vpolicy.col.maxDays': 'أطول زيارة',
  'vpolicy.col.stages': 'تسلسل الموافقة',
  'vpolicy.days': { one: 'يوم واحد', two: 'يومان', few: '{count} أيام', many: '{count} يومًا', other: '{count} يوم' },
  'vpolicy.noStages': 'دون موافقة',
  'vpolicy.restrictedStages': 'تُضاف للوجهات المقيدة',
  'vpolicy.inactive': 'غير نشطة',
  'vpolicy.req.purpose': 'الغرض',
  'vpolicy.req.destination': 'الوجهة',
  'vpolicy.req.visitor.email': 'بريد الزائر',
  'vpolicy.req.visitor.phone': 'جوال الزائر',
  'vpolicy.req.visitor.organisation': 'جهة الزائر',
  'vpolicy.draft': 'المسودة',
  'vpolicy.draftSub': 'الإصدار {number} · غير سارٍ حتى النشر',
  'vpolicy.startDraft': 'بدء مسودة من الإصدار الساري',
  'vpolicy.startOverride': 'إنشاء تجاوز خاص بالموقع',
  'vpolicy.categories': 'فئات الزوار',
  'vpolicy.addCategory': 'إضافة فئة',
  'vpolicy.removeCategory': 'إزالة الفئة',
  'vpolicy.code': 'الرمز',
  'vpolicy.labelEn': 'التسمية (الإنجليزية)',
  'vpolicy.labelAr': 'التسمية (العربية)',
  'vpolicy.active': 'نشطة',
  'vpolicy.maxDays': 'أطول زيارة (بالأيام)',
  'vpolicy.required': 'التفاصيل المطلوبة',
  'vpolicy.stages': 'مراحل الموافقة',
  'vpolicy.stagesHint': 'تعمل المراحل التي ليس لها مرحلة سابقة بالتوازي. يجب أن توافق كل مرحلة.',
  'vpolicy.addStage': 'إضافة مرحلة',
  'vpolicy.removeStage': 'إزالة المرحلة',
  'vpolicy.stageKey': 'رمز المرحلة',
  'vpolicy.resolver': 'من يقرّر',
  'vpolicy.resolver.site_approvers': 'أي معتمِد مؤهل في الموقع',
  'vpolicy.resolver.user': 'شخص محدد',
  'vpolicy.resolverUser': 'المعتمِد المحدد (معرّف المستخدم)',
  'vpolicy.afterStage': '{stage} (بعد {after})',
  'vpolicy.dependsOn': 'بعد',
  'vpolicy.maxOccurrences': 'أقصى عدد تكرارات في سلسلة واحدة',
  'vpolicy.note': 'ملاحظة التغيير',
  'vpolicy.saveDraft': 'حفظ المسودة',
  'vpolicy.saved': 'حُفظت المسودة.',
  'vpolicy.publish': 'نشر',
  'vpolicy.publishTitle': 'نشر الإصدار {number}؟',
  'vpolicy.publishBody': 'تستخدم الطلبات الجديدة وإعادات التقييم هذا الإصدار. تحتفظ القرارات الحالية بالإصدار الذي أنتجها.',
  'vpolicy.published': 'أصبح الإصدار {number} ساريًا.',
  'vpolicy.discard': 'تجاهل المسودة',
  'vpolicy.history': 'سجل الإصدارات',
  'vpolicy.col.version': 'الإصدار',
  'vpolicy.col.status': 'الحالة',
  'vpolicy.col.published': 'تاريخ النشر',
  'vpolicy.col.note': 'ملاحظة',
  'vpolicy.restore': 'استعادة كمسودة',
  'vpolicy.restoreHint': 'تُنشئ الاستعادة إصدارًا جديدًا؛ ولا يُحذف السجل أبدًا.',
  'vpolicy.readOnly': 'يمكنك قراءة هذه السياسة. يُجري مسؤولو المؤسسة التغييرات.',
  'vpolicy.status.draft': 'مسودة',
  'vpolicy.status.published': 'سارية',
  'vpolicy.status.superseded': 'مستبدلة',
  'vpolicy.status.discarded': 'متجاهلة',
  'policy.status.draft': 'مسودة',
  'policy.status.published': 'منشورة',
  'policy.status.superseded': 'مستبدلة',
  'policy.status.discarded': 'متجاهلة',

  'hosts.tab': 'دليل المضيفين',
  'hosts.title': 'دليل المضيفين',
  'hosts.sub': 'المضيفون منفصلون عن حسابات الدخول. يحصل المستخدمون الذين لديهم تجربة المضيف على ملف تلقائيًا.',
  'hosts.add': 'إضافة مضيف',
  'hosts.col.host': 'المضيف',
  'hosts.col.department': 'القسم',
  'hosts.col.employee': 'رقم الموظف',
  'hosts.col.account': 'حساب الدخول',
  'hosts.col.status': 'الحالة',
  'hosts.linked': 'مرتبط',
  'hosts.notLinked': 'لا يوجد',
  'hosts.source.self': 'من الحساب',
  'hosts.source.manual': 'أُضيف يدويًا',
  'hosts.source.directory': 'من الدليل',
  'hosts.source.import': 'مستورد',
  'hosts.displayName': 'الاسم',
  'hosts.email': 'البريد الإلكتروني',
  'hosts.employeeNumber': 'رقم الموظف',
  'hosts.department': 'القسم',
  'hosts.jobTitle': 'المسمى الوظيفي',
  'hosts.deactivate': 'إلغاء التفعيل',
  'hosts.reactivate': 'إعادة التفعيل',
  'hosts.impactTitle': 'أعِد إسناد الزيارات القادمة أولًا',
  'hosts.empty': 'لا يوجد مضيفون بعد.',
  'person.title': 'ملف الزائر',
  'person.history': 'سجل الزيارات',
  'person.partial': 'بعض الزيارات في مواقع خارج نطاق عرضك ولا تظهر.',
  'person.none': 'لا توجد زيارات ضمن نطاق عرضك.',
  'person.organisation': 'الجهة',
  'person.contact': 'الاتصال',

  'pass.title': 'أنت مدعو إلى {site}',
  'pass.greeting': 'أهلًا بك، {name}.',
  'pass.intro': 'دعاك {host}. اعرض هذه البطاقة في الاستقبال.',
  'pass.when': 'الموعد',
  'pass.daily': 'يوميًا {start}–{end}',
  'pass.where': 'المكان',
  'pass.host': 'المضيف',
  'pass.reference': 'المرجع',
  'pass.referenceHint': 'إذا تعذّر استخدام رمز QR، اذكر هذا المرجع في الاستقبال.',
  'pass.qr': 'رمز QR لمرجع الزيارة {reference}',
  'pass.calendar': 'إضافة إلى التقويم',
  'pass.directions': 'الاتجاهات والتعليمات',
  'pass.address': 'العنوان',
  'pass.attendance': 'هل ستحضر؟',
  'pass.confirm': 'سأحضر',
  'pass.decline': 'لا أستطيع الحضور',
  'pass.rsvp.confirmed': 'شكرًا — سُجّل ردّك ويمكن لمضيفك رؤيته.',
  'pass.rsvp.declined': 'شكرًا — سُجّل ردّك ويمكن لمضيفك رؤيته.',
  'pass.notEntry': 'هذه البطاقة وحدها لا تمنح الدخول. يؤكد الاستقبال وصولك في الموقع.',
  'pass.validUntil': 'يعمل هذا الرابط حتى {date}.',
  'pass.invalid.title': 'رابط الدعوة هذا غير صالح',
  'pass.invalid.body': 'ربما انتهت صلاحيته أو استُبدل، أو تغيّرت الزيارة. تواصل مع مضيفك للحصول على دعوة جديدة.',
  'pass.loading': 'جارٍ فتح بطاقة الزائر…',
  'inv.col': 'الدعوة',
  'inv.none': 'لم تُرسل',
  'inv.waiting': 'تُرسل بعد الموافقة',
  'inv.noEmail': 'لا يوجد بريد — شارك رابطًا',
  'inv.active': 'الرابط فعّال',
  'inv.viewed': 'فُتحت {when}',
  'inv.superseded': 'استُبدل برابط أحدث',
  'inv.revoked': 'سُحب الرابط',
  'inv.msg.queued': 'البريد في قائمة الانتظار',
  'inv.msg.accepted': 'قبلت خدمة البريد الرسالة',
  'inv.msg.failed': 'لم تُقبل الرسالة — تجري إعادة المحاولة',
  'inv.msg.blocked': 'حُجبت الرسالة: {reason}',
  'inv.msg.cancellation': 'إشعار الإلغاء',
  'inv.rsvp.none': 'لا رد',
  'inv.rsvp.confirmed': 'سيحضر',
  'inv.rsvp.declined': 'لا يستطيع الحضور',
  'inv.reissue': 'الدعوة…',
  'inv.reissueTitle': 'دعوة جديدة لـ{name}',
  'inv.reissueBody': 'يتوقف الرابط الحالي عن العمل فور المتابعة.',
  'inv.mode.email': 'إرسال بريد دعوة جديد',
  'inv.mode.link': 'إنشاء رابط لمشاركته بنفسي',
  'inv.reissueGo': 'متابعة',
  'inv.linkReady': 'شارك هذا الرابط مع {name}. يُعرض مرة واحدة فقط ويعمل حتى {date}.',
  'inv.emailQueued': 'بريد الدعوة الجديد في طريقه.',
  'inv.acceptedNote': 'تعني «قُبلت» أن خدمة البريد استلمت الرسالة — لا أنها قُرئت.',
};
